module.exports = __webpack_public_path__ + "static/media/impression.2cee2969.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/partner-reports/impression.svg
// module id = 544
// module chunks = 1